document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.featured-rugs-slider');
  
  sliders.forEach(slider => {
    const scrollContainer = slider.querySelector('.featured-rugs-scroll-container');
    const prevButton = slider.querySelector('.featured-rugs-nav-button.prev');
    const nextButton = slider.querySelector('.featured-rugs-nav-button.next');
    
    if (scrollContainer && prevButton && nextButton) {
      // Scroll amount (width of one rug item plus gap)
      const scrollAmount = 310; // 280px width + 30px gap
      
      prevButton.addEventListener('click', () => {
        scrollContainer.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      });
      
      nextButton.addEventListener('click', () => {
        scrollContainer.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      });
      
      // Hide/show navigation buttons based on scroll position
      const updateNavButtons = () => {
        const isAtStart = scrollContainer.scrollLeft <= 10;
        const isAtEnd = scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 10;
        
        prevButton.style.opacity = isAtStart ? '0.5' : '1';
        prevButton.style.pointerEvents = isAtStart ? 'none' : 'auto';
        
        nextButton.style.opacity = isAtEnd ? '0.5' : '1';
        nextButton.style.pointerEvents = isAtEnd ? 'none' : 'auto';
      };
      
      scrollContainer.addEventListener('scroll', updateNavButtons);
      window.addEventListener('resize', updateNavButtons);
      
      // Initial check
      updateNavButtons();
    }
  });
});